<ul class="nav-sublist-item">
  <li>
    <ng-content></ng-content>
  </li>
</ul>
